'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _AudioPlayerView = require('../components/UI/AudioPlayerView.jsx');

var _AudioPlayerView2 = _interopRequireDefault(_AudioPlayerView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return state.audioPlayer;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {};
};

var AudioPlayer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_AudioPlayerView2.default);

exports.default = AudioPlayer;


//////////////////
// WEBPACK FOOTER
// ./client/containers/audioPlayer.js
// module id = 70
// module chunks = 0